import { render } from "./DeleteClient.vue?vue&type=template&id=2b2ac166"
import script from "./DeleteClient.vue?vue&type=script&lang=js"
export * from "./DeleteClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__